import { css } from 'lit';

var css_248z = css`slot[name=nav][variant=tabs-basic-toggle]::slotted(sgds-tab){margin-left:-2px}`;

export { css_248z as default };
//# sourceMappingURL=sgds-tab-group2.js.map
